import { root } from 'effector-root'

export const domain = root.domain('InspectionEditor')
